import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import { ActivityButton } from 'components/ActivityButton'
import { useLayout } from 'hooks/useLayout'

export const ConfirmLeUserEmailChangeModal = ({
  isModalOpen,
  newEmail,
  isActive,
  onCancel,
  onConfirm,
}: {
  isModalOpen: boolean
  newEmail: string
  isActive: boolean
  onCancel: () => void
  onConfirm: () => void | Promise<void>
}) => {
  const { isMobile, isHeightUnder600, isHeightUnder400 } = useLayout()

  return (
    <Dialog
      fullScreen={isMobile}
      open={isModalOpen}
      maxWidth={'xl'}
      fullWidth
      PaperProps={{ sx: { p: 0, maxWidth: '800px' } }}
    >
      <DialogTitle bgcolor={grey[50]} sx={{ p: 0 }} className="border-b">
        <Box px={{ xs: 2, sm: 4 }} py={{ xs: 3, sm: 4 }}>
          <Typography variant="h3">Email Update</Typography>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{
          mb: '0px',
          zIndex: 0,
          overflow: 'auto',
          minHeight: 'fit-content',
          maxHeight: 'fit-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
        }}
      >
        <Box paddingTop={isHeightUnder400 ? 15 : isHeightUnder600 ? 5 : 3}>
          <Typography variant="h6" fontWeight={700} pb={'8px'}>
            {`Are you sure you want to update your email address to: ${newEmail}`}
          </Typography>
          <Typography variant="label-form" color={'text.secondary'}>
            Once changed, you won’t be able to log in with your previous email.
            Please double-check that your new email is correct and accessible.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className="border-t">
        <Box className="flex flex-row justify-end py-4 md:px-8 sm:px-4">
          <Button
            variant="text"
            onClick={() => {
              onCancel()
            }}
          >
            Cancel
          </Button>

          <ActivityButton
            active={isActive}
            type="submit"
            variant="contained"
            onClick={async () => {
              await onConfirm()
            }}
          >
            Save
          </ActivityButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}
